<ndt-add-location-view
   [callState]="callState | async"
   [form]="form"
   (formCanceled)="onCloseClick()"
   (formSubmitted)="onCreate()"
   (saveAndAddAnother)="onCreateAndAddAnother()"
>
</ndt-add-location-view>
